import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopSkills = async (HubIds: string[], ISICCodes?: string[], ISCO2Codes?: string[], ISCED4Codes?: string[], Locations?: string[], isEntryLevel?: boolean) => {
    const { path, method } = endpoints.skill.getTopSkills;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, ISCO2Codes, ISCED4Codes, Locations, isEntryLevel },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
